import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=2fc938e2&scoped=true&lang=pug"
import script from "./curriculum.vue?vue&type=script&lang=ts"
export * from "./curriculum.vue?vue&type=script&lang=ts"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=2fc938e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc938e2",
  null
  
)

export default component.exports